import NumberFormat from 'react-number-format'
import { useSelector } from 'react-redux'
import HelpTooltip from '../../../components/tooltip/HelpTooltip'

const WalletSpend = () => {
  const { status = [] } = useSelector(state => state.account.current)
  const {
    walletSpend: { todaySpend = 0, monthSpend = 0 },
  } = useSelector(state => state.dashboard.info)
  return (
    <div className="tab_cont">
      <h4 className="screen_out">비용 정보</h4>
      <div className="infosum_dash">
        <table className="tbl_infosum">
          <caption className="hide_caption">비용 정보 데이터 테이블</caption>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>
                <div className="inner_cell">
                  오늘 소진액
                  <HelpTooltip nowrap={false}>
                    오늘 소진되고 있는 실시간성 키워드광고비에 대한 현황을
                    빠르게 확인할 수 있도록 제공되는 금액으로 비즈월렛을
                    연결해야 하며, 정확한 소진액은 &apos;설정 &gt; 비즈월렛 관리
                    &gt; 캐시 관리&apos; 잔액을 통해 확인해주셔야 합니다.
                  </HelpTooltip>
                </div>
              </th>
              <td>
                <div className="inner_cell">
                  {status.includes('NOT_CONNECTED_BIZ_WALLET') ? (
                    '비즈월렛 미연결'
                  ) : (
                    <>
                      <NumberFormat
                        value={todaySpend}
                        displayType="text"
                        thousandSeparator
                        decimalScale={1}
                      />
                      원
                    </>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <div className="inner_cell">
                  이번달총소진액
                  <HelpTooltip nowrap={false}>
                    이번 달 1일부터 조회 시점의 소진된 부가세를 포함한
                    광고계정의 총 키워드 광고 비용을 의미하며, 상세한 총
                    소진액은 &apos;설정 &gt; 비즈월렛 관리 &gt; 캐시 관리 &gt;
                    자산별 캐시 사용 현황&apos;에서 확인 가능합니다.
                  </HelpTooltip>
                </div>
              </th>
              <td>
                <div className="inner_cell">
                  {status.includes('NOT_CONNECTED_BIZ_WALLET') ? (
                    '비즈월렛 미연결'
                  ) : (
                    <>
                      <NumberFormat
                        value={monthSpend}
                        displayType="text"
                        thousandSeparator
                        decimalScale={1}
                      />
                      원
                    </>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
export default WalletSpend
